<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="file_038"><strong>6.</strong> Needle a patch of black wool to cover the magnet. Needle the patch over the magnet and around the bottom of the bumblebee, being careful not to jab the needle into the magnet.</a></p><a id="file_038">
<p class="image"><img alt="Image" src="images/f0015-02.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_038.vue?06ac5832